import { ILocationContentfulData } from "../../services/contentful-service/contentful.interface";

export const actionTypes = {
  SET_CONTENTFUL_DATA: "SET_CONTENTFUL_DATA",
};

const setContentfulDataAction = (contentfulPayload: ILocationContentfulData | null) => ({
  type: actionTypes.SET_CONTENTFUL_DATA,
  payload: contentfulPayload,
});

export default {
  setContentfulDataAction,
};
